import { SignupFormSelector } from './containers/FormSelector'

export function SignUpEmailView(): JSX.Element {
  return <SignupFormSelector />
}
